import { render, staticRenderFns } from "./InspectionPersonnel.vue?vue&type=template&id=21fa476e&scoped=true"
import script from "./InspectionPersonnel.vue?vue&type=script&lang=js"
export * from "./InspectionPersonnel.vue?vue&type=script&lang=js"
import style0 from "./InspectionPersonnel.vue?vue&type=style&index=0&id=21fa476e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../wscpet/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fa476e",
  null
  
)

export default component.exports